export const dateParser = (date) => {
  if (typeof date === "string") return date;
  if (date) return date.toJSON().substring(0, 10);
  return null;
};
